import { registerPlugin } from "@capacitor/core";

export interface ActiveShiftData {
  isActive: boolean;
  isPaused?: boolean;
  type?: "block" | "commute";
  totalMiles?: number;
  startedAt?: number;
  station?: string;
  basePay?: number;
  bookedMinutes?: number;
}

export interface TodaySummaryData {
  blockCount: number;
  totalEarnings: number; // cents
  totalMinutes: number;
  totalMiles: number;
}

export interface WeeklyStatsData {
  totalEarnings: number; // cents
  hoursWorked: number;
  blockCount: number;
  avgHourlyRate: number; // cents
}

export interface WeeklyGoalData {
  goal: number | null; // cents, null if no goal
  currentEarnings: number; // cents
}

export interface NextBlockData {
  station: string;
  startTime: string; // HH:MM
  basePay: number; // cents
  date: string; // YYYY-MM-DD
}

export interface HoursRemainingData {
  dailyLimit: number;
  weeklyLimit: number;
  hoursWorkedToday: number;
  hoursWorkedThisWeek: number;
  hoursLeftToday: number;
  hoursLeftThisWeek: number;
  // New fields for true rolling windows
  bottleneck: "daily" | "weekly" | "none";
  nextReleaseTime: number | null; // Unix timestamp in ms, or null
  nextReleaseHours: number;
}

export interface PendingIntentAction {
  hasPendingAction: boolean;
  action?: "start" | "stop" | "pause" | "resume" | "deepLink";
  type?: "block" | "commute";
  deepLink?: string;
}

export interface WidgetSyncPlugin {
  syncActiveShift(data: ActiveShiftData): Promise<void>;
  syncTodaySummary(data: TodaySummaryData): Promise<void>;
  syncWeeklyStats(data: WeeklyStatsData): Promise<void>;
  syncWeeklyGoal(data: WeeklyGoalData): Promise<void>;
  syncNextBlock(data: NextBlockData | { station?: undefined }): Promise<void>;
  syncHoursRemaining(data: HoursRemainingData): Promise<void>;
  refreshWidgets(): Promise<void>;
  clearWidgetData(): Promise<void>;
  getPendingIntentAction(): Promise<PendingIntentAction>;
  getFCMToken(): Promise<{ token: string | null }>;
}

export const WidgetSync = registerPlugin<WidgetSyncPlugin>("WidgetSync");
